import * as React from 'react'
import { styled } from '@mui/material/styles'
import { FC, useCallback, useMemo } from 'react'
import { IMenuOption } from './MenuOption'

import ListItemButton, {
  listItemButtonClasses,
} from '@mui/material/ListItemButton'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import { getStyles } from './useStyles'

const StyledSubMenuListItem = styled(ListItemButton)({
  [`&.${listItemButtonClasses.root}`]: {
    '&:hover': {
      color: '#a4a4a4',
      backgroundColor: 'unset',
    },
  },
})

interface Props {
  item: IMenuOption
  handleLinkClick: (url: string) => void
  location: string
}

export const SubMenuItem: FC<Props> = (props) => {
  const {
    item: { label, url },
    handleLinkClick,
    location,
  } = props

  const onClick = useCallback(
    () => handleLinkClick(url),
    [handleLinkClick, url],
  )
  const dataTestId = useMemo(() => `${label}OptionLbl`, [label])

  const styles = getStyles(useTheme())
  return (
    <StyledSubMenuListItem
      onClick={onClick}
      disableGutters
      data-test-id={dataTestId}
    >
      <Box
        sx={{
          ...styles.subMenuListItem,
          ...(location == url && styles.subMenuListItemSelected),
        }}
      >
        <Typography
          sx={
            location == url
              ? styles.subMenuListItemTextSelected
              : styles.subMenuListItemText
          }
          display="inline"
        >
          {label}
        </Typography>
      </Box>
    </StyledSubMenuListItem>
  )
}
SubMenuItem.displayName = 'SubMenuItem'
